import ConsoleCapture from "./console-capture.js";
import SearchReplace from "./search-replace.js";
import Logger from "./logger.js";
import DOMPurify from "dompurify";

// Initialize ConsoleCapture immediately to intercept logs early
ConsoleCapture.enable();

let loggerInstance = null;

function getLogger() {
    if (!loggerInstance) {
        const restPath = (typeof window !== 'undefined' && window.Editor?.data?.restpath) || '';
        loggerInstance = new Logger(restPath);
    }
    return loggerInstance;
}

export {
    ConsoleCapture,
    SearchReplace,
    Logger,
    DOMPurify,
    getLogger
};
